import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AdsPlacement } from 'src/app/classes/ads-placement';
import { Product } from 'src/app/classes/product';
import * as fa from '@fortawesome/free-solid-svg-icons';
import { AdsPlacementService } from 'src/app/classes/ads-placement.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-picture',
  templateUrl: './picture.component.html',
  styleUrls: ['./picture.component.css']
})

export class PictureComponent implements OnInit, OnDestroy {

  adsPlacement: AdsPlacement = new AdsPlacement();
  product: Product

  // Index representing products array and -1 for main picture
  index: number

  title = '';
  picture = '';
  editPrompt = '';

  updating = false

  fa = fa

  updateSub: Subscription
  
  constructor(
    public activeModal: NgbActiveModal,
    private adsPlacementService: AdsPlacementService
  ) {}

  ngOnInit(): void {

    if(this.product) {
      this.title = this.product.name;
      this.picture = this.product.picture;
    } else {
      this.title = this.adsPlacement.name;
      this.picture = this.adsPlacement.assignment.picture;
      this.index = -1
    }

    this.updateSub = this.adsPlacementService.listen().subscribe((update) => {
      console.log(update)
      if(update.type == 'assignment' && update.ads_placement_id == this.adsPlacement.id) {
        this.adsPlacementService.get(this.adsPlacement.id).subscribe(adsPlacement => {
          this.adsPlacement.assignment.picture = adsPlacement.assignment.picture;
          this.picture = this.adsPlacement.assignment.picture;
          this.updating = false
        })
          
      }

      if(update.type == 'product' && update.ads_placement_id == this.adsPlacement.id) { 
        const product = this.adsPlacement.assignment.products.find(p => p.product.id == update.product_id)
        
        this.adsPlacementService.productPicture(this.adsPlacement.id, product.product.id).subscribe((picture) => {
          if(product) {
            product.product.picture = picture.url;
            this.picture = product.product.picture;
            this.updating = false
          }
        })
      }    })
  }

  ngOnDestroy(): void {
    this.updateSub.unsubscribe();
  }

  edit() {
    this.updating = true

    this.adsPlacementService.editPicture(this.adsPlacement.id, this.product?.id, this.editPrompt).subscribe((productIds) => {
      this.editPrompt = '';
    });
  }

  discard() {
    if(!confirm($localize`Are you sure?`)) return

    this.adsPlacementService.discardPicture(this.adsPlacement.id, this.product?.id).subscribe(() => {
      
    });
  }

  previous() {
    this.index--

    if(this.index == -1) {
      this.picture = this.adsPlacement.assignment.picture;
      this.product = undefined;
    }
    else if(this.index < -1) {
      this.index = this.adsPlacement.assignment.products.length-1
      this.product = this.adsPlacement.assignment.products[this.index].product;
      this.picture = this.product.picture;
    }
    else {
      this.product = this.adsPlacement.assignment.products[this.index].product;
      this.picture = this.product.picture;
    }
  }

  next() {
    this.index++

    if(this.index >= this.adsPlacement.assignment.products.length) {
      this.index = -1
      this.picture = this.adsPlacement.assignment.picture;
      this.product = undefined;
    }
    else {
      this.product = this.adsPlacement.assignment.products[this.index].product;
      this.picture = this.product.picture;
    }
  }
}
